import React from "react";
import { CtaButton } from "./CtaButton";
import { images } from "../data/content";
const questions = ["What information should you record first?", "Which findings are confirmed?", "Which possibilities still need to be investigated?", "What should you check next?"];
export function Author() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-19" data-mp="et1gs04aq0tb">
      <div className="mx-auto grid max-w-5xl items-start gap-10 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]" data-id="element-20" data-mp="12hu7ni629ih2">
        <div className="md:sticky md:top-8" data-id="element-21" data-mp="17h73utito1wb">
          <img src={images.author} alt="Jason Mitchell, automotive electronics specialist, in his workshop" className="w-full rounded-3xl object-cover" data-id="element-22" data-mp="17fw2f0cun68d" />
          <p className="mt-4 text-center font-display text-xl font-extrabold text-ink" data-id="element-23" data-mp="xgmzvj3x4jae">Jason Mitchell</p>
          <p className="text-center text-sm text-ink-muted" data-id="element-24" data-mp="3d8axlgqrafu9">Automotive Electronics Specialist</p>
        </div>

        <div data-id="element-25" data-mp="3i6ccrql29v0g">
          <p className="text-sm font-bold uppercase tracking-wider text-brand" data-id="element-26" data-mp="1tykarhgd0z8t">A message from Jason Mitchell</p>
          <h2 className="mt-2 font-display text-[30px] font-extrabold leading-[1.1] text-ink sm:text-4xl" data-id="element-27" data-mp="1ozqw3lpc7272">
            Why I Created the CAN Bus Diagnostic Blueprint™
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink-soft" data-id="element-28" data-mp="1y05fugmnk98g">
            <p data-id="element-29" data-mp="1y29rxlupgejt">
              After spending time studying the challenges involved in automotive electronic diagnosis, one problem
              became increasingly clear to me:
            </p>
            <p className="font-semibold text-ink" data-id="element-30" data-mp="27w8s4fb7xo94">
              Technicians can have access to diagnostic scanners, technical information, wiring diagrams, and years
              of experience—and still struggle to organize a complicated investigation.
            </p>
            <p data-id="element-31" data-mp="2vopcwxmcbuc4">
              The challenge isn't always finding more information. Sometimes, it's knowing how to put the
              information you already have to work.
            </p>
            <ul className="space-y-2 border-l-4 border-brand pl-4" data-id="element-32" data-mp="1ocg66caz2d09">
              {questions.map(q => <li key={q} className="font-display text-lg font-bold text-ink" data-id="element-33" data-mp="1sdtequ5g8uav">
                  {q}
                </li>)}
            </ul>
            <p data-id="element-34" data-mp="222jo4r2tjkjw">
              Those are the questions that inspired the CAN Bus Diagnostic Blueprint: a collection of visual
              workflows, decision frameworks, investigation templates, and documentation tools that technicians can
              consult while organizing their work.
            </p>
            <p data-id="element-35" data-mp="2g22vhhnt2rv5">
              Not another enormous technical textbook. Not a promise that one flowchart can solve every
              communication fault. And certainly not a replacement for proper training or manufacturer-specific
              service information.
            </p>
            <p data-id="element-36" data-mp="qnobtbrn9v6i">
              My goal is to help you bring more structure to your diagnostic process, so you can focus your technical
              knowledge on the case in front of you.
            </p>
            <p className="font-display text-xl font-bold text-ink" data-id="element-37" data-mp="edov3zr5jjk4">— Jason Mitchell</p>
          </div>

          <div className="mt-8" data-id="element-38" data-mp="9e2h3o3i1za9">
            <CtaButton label="Start with Jason's Blueprint" arrow data-id="element-39" data-mp="9f3u3y42svum" />
          </div>
        </div>
      </div>
    </section>;
}